import './styles.css'

const Head = () => (
  <div className='head'>
    <span className='eye left' />
    <span className='eye right' />
    <span className='lips' />
  </div>
)

export default Head